// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__18iek","inner":"Footer_inner__3KF7x"};